import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { approvalFormTableStyles } from '@/components/Approval/@components/ApprovalFormTable/styles';
import { infoSectionTitleStyles } from '@/components/Approval/@components/InfoSection/styles';

/** 저장 HTML(레거시 문서 포함)의 태그·클래스로 맞춤 — 레거시 섹션 제목은 label.label */
export const SerpStoreReturnRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& label.label': {
    ...infoSectionTitleStyles,
    display: 'block',
    margin: '0 0 8px',
  },
  '& table': {
    ...approvalFormTableStyles(theme),
    tableLayout: 'fixed',
    minWidth: 560,
  },
  '& table + table, & table + label.label': {
    marginTop: 16,
  },
  '& table th, & table td': {
    textAlign: 'center',
    wordBreak: 'keep-all',
    overflowWrap: 'anywhere',
  },
  '& tbody th': {
    fontWeight: 400,
  },
}));

export const SerpStoreReturnDetailButtonRow = styled(Box)({
  marginTop: 16,
  '& > button': {
    width: '100%',
  },
});

export const SerpStoreReturnDetailRoot = styled(SerpStoreReturnRoot)({
  '& table': {
    minWidth: 640,
  },
});

export const SerpStoreReturnSheetBody = styled(Box)({
  padding: '16px 16px 24px',
});
